import React, { useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import axios from "axios";

import { accounts } from "../../utils/appConstants";
import api from "../../utils/api";

const favoriteGroups = [
	{ group: "NL", groups: ["NL Credit", "NL Accounts", "Immerge", "Investing", "Retirement"] },
	{ group: "Erin", groups: ["Erin Accounts", "Retirement"] },
];

const AddAccountBalance = () => {
	const [accountValues, setAccountValues] = useState({});
	const navigate = useNavigate();
	const { group } = useParams(); // Expects "NL" or "Erin"

	const matchedFavorite = favoriteGroups.find((fav) => fav.group === group);

	// Filter accounts belonging to allowed subgroups
	const favoriteAccounts = matchedFavorite ? accounts.filter((acc) => matchedFavorite.groups.includes(acc.group)) : [];

	// Organize accounts into a map: { subgroup -> accounts[] }
	const accountsBySubgroup = {};

	favoriteAccounts.forEach((acc) => {
		if (!accountsBySubgroup[acc.group]) {
			accountsBySubgroup[acc.group] = [];
		}
		accountsBySubgroup[acc.group].push(acc);
	});

	const handleChange = (accountName, value) => {
		setAccountValues((prev) => ({
			...prev,
			[accountName]: value,
		}));
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		const submissionData = Object.entries(accountValues)
			.filter(([_, value]) => value !== "" && Number(value) !== 0)
			.map(([account, value]) => ({
				account,
				value,
				date_edited: new Date().toISOString().slice(0, 10),
			}));

		console.log("submissionData:", submissionData);

		if (submissionData.length === 0) {
			console.log("No valid data to submit.");
			return;
		}

		try {
			await api.post(`/money/multipleAccountBalances`, submissionData);
			navigate("/accountBalance");
		} catch (err) {
			console.log(err);
		}
	};

	return (
		<section className="lavella page add-account-balance">
			<div className="container--sm">
				<Link to="/dashboard" style={{ marginBottom: "10px" }} className="l-btn">
					Back
				</Link>
				<h3>Add Account Balance - {group}</h3>
				<div className="form">
					<div className="card-layout halves">
						{Object.keys(accountsBySubgroup).length > 0 ? (
							Object.entries(accountsBySubgroup).map(([subgroup, accounts]) => (
								<div key={subgroup} className="card light">
									<h4 className="title4">{subgroup}</h4>
									<div className="table horizontal">
										{accounts.map((account) => (
											<div className="row" key={account.account}>
												<div className="col hd">
													<p>{account.name || account.account}</p>
												</div>
												<div className="col">
													<input type="number" placeholder="$0.00" value={accountValues[account.account] || ""} onChange={(e) => handleChange(account.account, e.target.value)} />
												</div>
											</div>
										))}
									</div>
								</div>
							))
						) : (
							<p>No accounts found for this group.</p>
						)}
					</div>

					<div className="field submit">
						<div className="l-btn" onClick={handleSubmit}>
							Add
						</div>
					</div>
				</div>
			</div>
		</section>
	);
};

export default AddAccountBalance;
